module.exports = __webpack_public_path__ + "img/Pop-up_01_1.0002c272.png";